<form [formGroup]="form">
  <h4 class="fw-bold my-4">Filtra deleghe</h4>
  <div class="row g-2 pe-1">
    <div class="col-6">
      <label class="form-label" for="anno">Anno</label>
      <input
        type="number"
        id="anno"
        formControlName="anno"
        class="form-control"
        min="2025"
        max="2099"
      />
    </div>
    <div class="col-6">
      <label class="form-label" for="mese">Mese</label>
      <select formControlName="mese" class="form-select" id="mese">
        <option [ngValue]="null">-</option>
        <option *ngFor="let m of mesi" [ngValue]="m.value">
          {{ m.label }}
        </option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label" for="delegante">Delegante</label>
      <input
        type="text"
        id="delegante"
        formControlName="delegante"
        class="form-control"
        maxlength="50"
      />
    </div>
    <div class="col-6">
      <label class="form-label" for="delegato">Delegato</label>
      <input
        type="text"
        id="delegato"
        formControlName="delegato"
        class="form-control"
        maxlength="50"
      />
    </div>
    <div class="col-12 d-flex justify-content-end mt-4 mb-4">
      <button
        (click)="search(true)"
        type="button"
        class="btn btn-outline-primary fw-semibold me-2"
      >
        Reset
      </button>
      <button
        (click)="search()"
        type="submit"
        class="btn btn-primary fw-semibold"
      >
        Cerca
      </button>
    </div>
  </div>
</form>
